import api from "./axios";

export const getTradingOverview = () => api.get("/auto/overview");
